import { useNavigate } from "react-router";
import useLocalStorage from "./useLocalStorage";
import dayjs from "dayjs";
import { PUBLIC_BASE } from "../shared/lib/routesResolver";

const useAuthentication = () => {
  const navigate = useNavigate();
  const storage = useLocalStorage();

  return {
    login: async (username, password) => {
      return fetch(`${process.env.REACT_APP_BASE_URL}/login`, {
        method: "POST",
        body: JSON.stringify({ username: username, password: password }),
        headers: {
          "Content-type": "application/json",
        },
      });
    },
    logout: () => {
      storage.clear();
      navigate(PUBLIC_BASE);
    },
    isLogged: () => {
      const token = storage.getAccessToken();
      return token !== null;
    },
    userLogged: () => {
      return storage.getUser();
    },
    tokenIsValid: () => {
      const today = dayjs();
      const expirationDate = storage.getTokenExpirationDate();

      if (expirationDate === null) {
        return false;
      }

      return today.isBefore(expirationDate);
    },
  };
};

export default useAuthentication;
